<div class="card m-1">
    <div class="card-body">
        <app-import-file (fileImported)="onFileImported($event)"
        (fileImportFailed)="onFileImportFailed($event)"></app-import-file>
        <div class="pt-2">
            <app-import-file-list #importFileList></app-import-file-list>
        </div>
    </div>
</div>
